import { useRef, useState } from "react";
import { applyKeypadKey, KEYPAD_DELETE } from "../utils/keypad";

export const useRiskKeypad = (risk) => {
  const [activeField, setActiveField] = useState("tp");
  const inputRef = useRef(null);
  // Both fields are armed on open: the first digit or "." replaces the value
  const [overtype, setOvertype] = useState({ tp: true, sl: true });

  const isTp = activeField === "tp";
  const draft = isTp ? risk.tpDraft : risk.slDraft;
  const setInput = isTp ? risk.setTpInput : risk.setSlInput;
  const isOvertype = overtype[activeField];

  const dismissOvertype = () =>
    setOvertype((prev) => ({ ...prev, [activeField]: false }));

  const onKeyPress = (key) => {
    inputRef.current?.focus();
    setInput(applyKeypadKey(draft, key, { isOvertype }));
    if (isOvertype && key !== KEYPAD_DELETE) dismissOvertype();
  };

  const onFocus = () => {};

  const onBlur = () => {};

  const swapField = () => {
    (isTp ? risk.onTpBlur : risk.onSlBlur)();
    setActiveField(isTp ? "sl" : "tp");
  };

  const switchMode = (nextMode) => {
    risk.switchMode(nextMode);
  };

  const formatAll = () => {
    risk.onTpBlur();
    risk.onSlBlur();
  };

  return {
    isTp,
    inputRef,
    draft: draft || "0",
    isOvertype,
    dismissOvertype,
    otherValue: (isTp ? risk.slDraft : risk.tpDraft) || "0",
    onKeyPress,
    onFocus,
    onBlur,
    swapField,
    switchMode,
    formatAll,
  };
};
